// project imports
import getColors from 'utils/getColors';
import getShadow from 'utils/getShadow';

// ==============================|| OVERRIDES - INPUT BORDER & SHADOWS ||============================== //

function getColor({ variant, theme }) {
  const colors = getColors(theme, variant);
  const { light } = colors;

  const shadows = getShadow(theme, `${variant}`);

  return {
    '&:hover .MuiOutlinedInput-notchedOutline': { borderColor: light },
    '&.Mui-focused': { boxShadow: shadows, '& .MuiOutlinedInput-notchedOutline': { border: '1px solid', borderColor: light } }
  };
}

// ==============================|| OVERRIDES - OUTLINED INPUT ||============================== //

export default function OutlinedInput(theme) {
  return {
    MuiOutlinedInput: {
      styleOverrides: {
        input: {
          padding: '0px 12px',
          height: 36,
          minHeight: 'unset',
          boxSizing: 'border-box'
        },
        notchedOutline: {
          borderColor: theme.vars.palette.grey[300],
          borderRadius: 4,
          borderWidth: 1,
          '& legend': {
            width: '0.01px',
            display: 'none',
            visibility: 'hidden'
          }
        },
        root: {
          backgroundColor: theme.vars.palette.common.white,
          borderRadius: 4,
          height: 36,
          minHeight: 'unset',
          '& .MuiOutlinedInput-notchedOutline legend': {
            width: 0,
            display: 'none'
          },
          '&:hover .MuiOutlinedInput-notchedOutline': {
            borderColor: theme.vars.palette.grey[400]
          },
          '&.Mui-focused': {
            boxShadow: 'none',
            '& .MuiOutlinedInput-notchedOutline': {
              border: '1.5px solid',
              borderColor: theme.vars.palette.primary.main
            }
          },
          '&.Mui-error': {
            ...getColor({ variant: 'error', theme })
          }
        },
        sizeSmall: {
          height: 30,
          minHeight: 'unset',
          '& .MuiOutlinedInput-input': {
            padding: '0px 10px'
          },
          '&.MuiInputBase-multiline': {
            height: 'auto !important',
            minHeight: 60
          }
        },
        multiline: {
          height: 'auto !important',
          minHeight: 60,
          padding: '8px 12px',
          '& .MuiOutlinedInput-input': {
            height: 'auto !important',
            padding: 0
          }
        },
        colorSecondary: getColor({ variant: 'secondary', theme }),
        colorError: getColor({ variant: 'error', theme }),
        colorWarning: getColor({ variant: 'warning', theme }),
        colorInfo: getColor({ variant: 'info', theme }),
        colorSuccess: getColor({ variant: 'success', theme })
      }
    }
  };
}
